"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snippetCode = void 0;
const analyticsTemplate = `!function(){var t=window[window.GoogleAnalyticsObject||"ga"];t&&t("provide",
"SegmentStream",function(t){var o,r,e=t.get("sendHitTask"),n=(o=[
"__COOKIE_WHITELIST__"],r="__ORIGIN__/ds/__DATASTREAM_ID__",{send:function(t){
var e=document.cookie.split(";").reduce(function(t,e){var n=e.split("=").map(
function(t){return t.trim()}),i=n[0];return-1===o.indexOf(i)?t:(t?t+"&":""
)+"cookie["+i+"]="+n[1]},"");e.length&&(t+=(t?"&":"")+e);var n,i=!1;if(
t.length<=2036&&(i=a(t)),i||"function"!=typeof navigator.sendBeacon||(
i=navigator.sendBeacon(r,t)),!i)try{window.XMLHttpRequest&&"withCredentials"in(
n=new XMLHttpRequest)&&(n.open("POST",r,!0),n.setRequestHeader("Content-Type",
"text/plain"),n.send(t),i=!0)}catch(t){}return i=i||a(t)}});function a(t){try{
return document.createElement("img").src=r+"?"+t,!0}catch(t){}return!1}t.set(
"sendHitTask",function(t){try{e(t)}catch(t){}n.send(t.get("hitPayload"))})})}();`;
const gtmTemplate = `function ssgtm(){return function(e){var n,r,i,o;function a(t){try{
return document.createElement("img").src=o+"?"+t,!0}catch(t){}return!1}
void 0===e.get("SegmentStream")&&(n=e.get("sendHitTask"),i=[
"__COOKIE_WHITELIST__"],o="__ORIGIN__/ds/__DATASTREAM_ID__",r={send:function(t){
var e=document.cookie.split(";").reduce(function(t,e){var n=e.split("=").map(
function(t){return t.trim()}),r=n[0];return-1===i.indexOf(r)?t:(t?t+"&":""
)+"cookie["+r+"]="+n[1]},"");e.length&&(t+=(t?"&":"")+e);var n,r=!1;if(
t.length<=2036&&(r=a(t)),r||"function"!=typeof navigator.sendBeacon||(
r=navigator.sendBeacon(o,t)),!r)try{window.XMLHttpRequest&&"withCredentials"in(
n=new XMLHttpRequest)&&(n.open("POST",o,!0),n.setRequestHeader("Content-Type",
"text/plain"),n.send(t),r=!0)}catch(t){}return r=r||a(t)}},e.set("sendHitTask",
function(t){n(t),r.send(t.get("hitPayload")),e.set("SegmentStream",!0)}))}}`;
const gtmOnlyBQTemplate = `function ssgtm(){return function(e){var n,i,o;function a(t){try{
return document.createElement("img").src=o+"?"+t,!0}catch(t){}return!1}
void 0===e.get("SegmentStream")&&(e.get("sendHitTask"),i=["__COOKIE_WHITELIST__"
],o="__ORIGIN__/ds/__DATASTREAM_ID__",n={send:function(t){
var e=document.cookie.split(";").reduce(function(t,e){var n=e.split("=").map(
function(t){return t.trim()}),r=n[0];return-1===i.indexOf(r)?t:(t?t+"&":""
)+"cookie["+r+"]="+n[1]},"");e.length&&(t+=(t?"&":"")+e);var n,r=!1;if(
t.length<=2036&&(r=a(t)),r||"function"!=typeof navigator.sendBeacon||(
r=navigator.sendBeacon(o,t)),!r)try{window.XMLHttpRequest&&"withCredentials"in(
n=new XMLHttpRequest)&&(n.open("POST",o,!0),n.setRequestHeader("Content-Type",
"text/plain"),n.send(t),r=!0)}catch(t){}return r=r||a(t)}},e.set("sendHitTask",
function(t){
// originalSendHitTask(model);
n.send(t.get("hitPayload")),e.set("SegmentStream",!0)}))}}`;
const analyticsPrefix = `// insert this snippet after ga('create', 'UA-XXXXX-Y', 'auto'); and before ga('send', 'pageview');
ga('__NAMESPACE__require', 'SegmentStream');
`;
const yandexTurboPageTemplate = `https://track.segmentstream.com/ds/__DATASTREAM_ID__?v=1&ds=Turbo&dr={referrer}&dt={pageTitle}&sr={screenWidth}x{screenHeight}&cid={clientId}&dl={originalURL}&t=pageview`;
const ampGtmPageTemplate = `https://track.segmentstream.com/ds/__DATASTREAM_ID__?v=1&ds=AMP&dt={{Document Title}}&sr={{Screen Width}}x{{Screen Height}}&cid={{Page Client ID}}&dl={{Page URL}}&dr={{Document Referrer}}&ul={{Browser Language}}&t=pageview`;
const ampHtmlPageTemplate = '<amp-analytics>\n' +
    '<script type="application/json">\n' +
    '{\n' +
    '  "requests": {\n' +
    '\t\t"pageview": "https://track.segmentstream.com/ds/{DATA_STREAM_ID}?v=1&ds=AMP&dt=${title}&sr=${screenWidth}x${screenHeight}&cid=${clientId}&dl=${canonicalUrl}&dr=${documentReferrer}&ul=${browserLanguage}&t=pageview"\n' +
    '  },\n' +
    '  "triggers": {\n' +
    '    "trackPageview": {\n' +
    '      "on": "visible",\n' +
    '      "request": "pageview"\n' +
    '    }\n' +
    '  }\n' +
    '}\n' +
    '</script>\n' +
    '</amp-analytics>';
const shopifyCheckoutTemplate = '{% if first_time_accessed %}\n' +
    '<!-- SegmentStream Universal Analytics Shopify Snippet -->\n' +
    '<script>\n' +
    '!function(){var a="https://track.segmentstream.com/ds/__DATASTREAM_ID__";function c(e){try{return document.createElement("img").src=a+"?"+e,!0}catch(e){}return!1}var e="";try{e=document.cookie.match(/_ga=(.+?);/)[1].split(".").slice(-2).join(".")}catch(e){}var t=encodeURIComponent(document.title),n=encodeURIComponent(document.referrer),r=encodeURIComponent(document.location.href);!function(e){var t,n=!1;if(!(n=!(n=e.length<=2036?c(e):n)&&"function"==typeof navigator.sendBeacon?navigator.sendBeacon(a,e):n))try{window.XMLHttpRequest&&"withCredentials"in(t=new XMLHttpRequest)&&(t.open("POST",a,!0),t.setRequestHeader("Content-Type","text/plain"),t.send(e),n=!0)}catch(e){}n=n||c(e)}(["v=1","t=pageview","cid="+e,"ti={% if order.name %}{{ order.name | url_encode }}{% else %}{{ checkout.id }}{% endif %}","tr={{ total_price | money_without_currency | replace: \',\', \'.\' }}","cu={{ currency }}","ta=Web","sr="+(screen.width+"x"+screen.height),"ul="+(navigator.languages&&navigator.languages[0]||navigator.language||navigator.userLanguage),"dl="+r,"dt="+t,"dr="+n,"pa=purchase"].join("&"))}();\n' +
    '</script>\n' +
    '<!-- END SegmentStream Universal Analytics Shopify Snippet -->\n' +
    '{% endif %}';
function snippetCode(origin, dataStreamID, cookieNamesWhitelist, type, analyticsNamespace = '') {
    let snippetTemplate;
    if (type === 'analytics') {
        snippetTemplate = analyticsPrefix + analyticsTemplate;
    }
    else if (type === 'gtm') {
        snippetTemplate = gtmTemplate;
    }
    else if (type === 'yandexTurboPage') {
        snippetTemplate = yandexTurboPageTemplate;
    }
    else if (type === 'ampGtm') {
        snippetTemplate = ampGtmPageTemplate;
    }
    else if (type === 'ampHtml') {
        snippetTemplate = ampHtmlPageTemplate;
    }
    else if (type === 'shopifyCheckout') {
        snippetTemplate = shopifyCheckoutTemplate;
    }
    else if (type === 'gtmOnlyBQ') {
        snippetTemplate = gtmOnlyBQTemplate;
    }
    return snippetTemplate
        .replace('__ORIGIN__', origin)
        .replace('__DATASTREAM_ID__', dataStreamID)
        .replace(/\[\s*"__COOKIE_WHITELIST__"\s*\]/, JSON.stringify(cookieNamesWhitelist))
        .replace('__NAMESPACE__', analyticsNamespace ? analyticsNamespace + '.' : '');
}
exports.snippetCode = snippetCode;
